export default __webpack_public_path__ + "static/media/coaches-training4.3a485acf.png";